import { FetchPurchaseMotionRequestTypes } from '../actions/PurchaseMotionActions';
const initialState = {};
const PurchaseMotionsByLocation = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchPurchaseMotionRequestTypes.RECEIVE:
      // merge new purchase motion locations with existing locations
      return Object.assign({}, state, payload.data);
    default:
      return state;
  }
};
export default PurchaseMotionsByLocation;